// ═══════════════════════════════════════════════════════════════════════════════
// Pair invite expired / invalid join — dedicated page
// ═══════════════════════════════════════════════════════════════════════════════

import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { appButtonClassName } from '../../components/ui/AppButton';

export const PairInviteExpiredPage = () => {
  const { t } = useLanguage();

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4 dark:bg-gray-950">
      <div className="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-lg dark:bg-gray-900">
        <h1 className="text-xl font-bold text-gray-900 dark:text-white" id="pair-invite-expired-heading">
          {t('pairing.invite.expiredTitle')}
        </h1>
        <p className="mt-3 text-sm text-gray-600 dark:text-gray-300">
          {t('pairing.invite.expiredBody')}
        </p>
        <p className="mt-2 text-sm font-medium text-gray-800 dark:text-gray-100">
          {t('pairing.invite.contactEmployer')}
        </p>
        <Link
          to="/"
          className={appButtonClassName({ variant: 'primary', fullWidth: true, className: 'mt-8' })}
          aria-labelledby="pair-invite-expired-heading"
        >
          {t('auth.goToHome')}
        </Link>
      </div>
    </div>
  );
};
